import React, { type ComponentRef, type ForwardedRef, useMemo } from 'react'
import { View, type ViewStyle } from 'react-native'
import { buildLinearGradient, type GradientProps } from './shared'

export const Gradient = React.forwardRef(function GradientComponent(
  props: GradientProps,
  ref: ForwardedRef<ComponentRef<typeof View>>,
) {
  const { colors, start = { x: 0, y: 0 }, end = { x: 0, y: 1 }, locations, style, pointerEvents, children } = props
  const backgroundImage = useMemo(
    () => buildLinearGradient(colors, start, end, locations),
    [colors, start, end, locations],
  )

  const viewStyle =
    pointerEvents !== undefined
      ? ([{ backgroundImage } as ViewStyle, style, { pointerEvents }] as ViewStyle[])
      : ([{ backgroundImage }, style] as ViewStyle[])

  return (
    <View ref={ref} style={viewStyle}>
      {children}
    </View>
  )
})
